import { ChevronDownIcon } from '@radix-ui/react-icons';
import React from 'react';

import { cssVars } from './css-vars';
import styles from './row-header.module.scss';

import type { GanttRenderers, Row } from '../types';

type RowHeaderProps = {
  row: Row;
  renderers?: GanttRenderers;
  onToggleCollapsed: (id: string) => void;
};

export const RowHeader: React.FC<RowHeaderProps> = ({ row, renderers, onToggleCollapsed }) => {
  const Custom = renderers?.rowHeader;

  return (
    // `rowheader` rather than `gridcell`: this is the cell that NAMES the row, and a `row` with
    // no `rowheader`/`gridcell`/`columnheader` child of its own is an `aria-required-children`
    // violation whatever it contains.
    <div
      role="rowheader"
      data-role="row-header"
      className={styles['header']}
      style={cssVars({ '--row-depth': row.depth })}
    >
      {row.isGroup ? (
        <button
          type="button"
          className={styles['chevron']}
          data-collapsed={row.isCollapsed}
          aria-label={row.isCollapsed ? `Expand ${row.item.name}` : `Collapse ${row.item.name}`}
          aria-expanded={!row.isCollapsed}
          onClick={() => onToggleCollapsed(row.id)}
        >
          <ChevronDownIcon />
        </button>
      ) : null}

      {Custom ? <Custom row={row} /> : <span className={styles['name']}>{row.item.name}</span>}
    </div>
  );
};
